/* Reloopo preview: native controls, live Shopify variants, no third-party runtime. */
(() => {
  'use strict';
  document.documentElement.classList.add('r2-js');
  const strings = JSON.parse(document.querySelector('[data-r2-ui-strings]')?.textContent || '{}');
  const t = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('{{ ' + name + ' }}', String(value)).replaceAll('__' + name + '__', String(value)), strings[key] || key);
  const root = window.Shopify?.routes?.root || '/';
  // Reserve space for Shopify's own preview bar; it sits above storefront layers.
  const watchPreviewBar = () => {
    const bar = document.getElementById('PBarNextFrameWrapper');
    if (!bar || bar.dataset.r2Observed) return;
    bar.dataset.r2Observed = 'true';
    const sync = () => document.documentElement.style.setProperty('--r2-preview-offset', Math.max(0, Math.min(100, bar.getBoundingClientRect().height)) + 'px');
    new ResizeObserver(sync).observe(bar); sync();
  };
  watchPreviewBar();
  const barObserver = new MutationObserver(watchPreviewBar); barObserver.observe(document.body, {childList:true});
  const toastEl = document.querySelector('[data-r2-toast]');
  const toastHeader = document.querySelector('.r2-header');
  const toastCart = toastHeader?.querySelector('.r2-cart-link');
  let toastPositionFrame;
  const positionToast = () => {
    if (!toastEl || toastEl.hidden || !toastEl.classList.contains('r2-toast-checkout') || !toastCart) return;
    const cart = toastCart.getBoundingClientRect();
    const header = toastHeader.getBoundingClientRect();
    const box = toastEl.getBoundingClientRect();
    const rtl = getComputedStyle(toastEl).direction === 'rtl';
    const left = Math.max(16, Math.min(innerWidth - box.width - 16, rtl ? cart.left : cart.right - box.width));
    // Anchor below the header; keep the confirmation visible when the header scrolls away.
    const top = Math.max(16, Math.min(innerHeight - box.height - 16, header.bottom + 8));
    toastEl.style.setProperty('--r2-toast-left', left + 'px');
    toastEl.style.setProperty('--r2-toast-top', top + 'px');
    toastEl.style.setProperty('--r2-toast-pointer', Math.max(24, Math.min(box.width - 24, cart.left + cart.width / 2 - left)) + 'px');
    toastEl.toggleAttribute('data-r2-toast-anchored', cart.bottom > 0 && cart.top < innerHeight && top >= header.bottom && header.bottom > 0);
  };
  const queueToastPosition = () => {
    if (!toastEl || toastEl.hidden || toastPositionFrame) return;
    toastPositionFrame = requestAnimationFrame(() => { toastPositionFrame = null; positionToast(); });
  };
  let toastTimer, toastFadeTimer, toastHovered = false, toastTrigger;
  const pauseToast = () => {
    clearTimeout(toastTimer); clearTimeout(toastFadeTimer);
    toastEl?.classList.remove('is-fading');
  };
  const dismissToast = () => {
    pauseToast();
    if (!toastEl) return;
    if (toastEl.contains(document.activeElement)) toastTrigger?.focus({preventScroll:true});
    toastEl.hidden = true;
  };
  const scheduleToast = () => {
    pauseToast();
    if (!toastEl || toastEl.hidden || toastHovered || toastEl.contains(document.activeElement)) return;
    toastTimer = setTimeout(() => {
      toastEl.classList.add('is-fading');
      toastFadeTimer = setTimeout(dismissToast, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 650);
    }, toastEl.classList.contains('r2-toast-checkout') ? 8000 : 4500);
  };
  if (toastEl) {
    window.addEventListener('scroll', queueToastPosition, {passive:true});
    window.addEventListener('resize', queueToastPosition);
    const toastResize = new ResizeObserver(queueToastPosition);
    toastResize.observe(toastEl);
    if (toastHeader) toastResize.observe(toastHeader);
    toastEl.addEventListener('pointerenter', event => {
      if (event.pointerType === 'mouse') { toastHovered = true; pauseToast(); }
    });
    toastEl.addEventListener('pointerleave', () => { toastHovered = false; scheduleToast(); });
    toastEl.addEventListener('focusin', pauseToast);
    toastEl.addEventListener('focusout', () => setTimeout(scheduleToast, 0));
    toastEl.addEventListener('pointerdown', pauseToast);
    toastEl.addEventListener('pointerup', scheduleToast);
    toastEl.addEventListener('pointercancel', scheduleToast);
    toastEl.addEventListener('keydown', event => { if (event.key === 'Escape') dismissToast(); });
    toastEl.querySelector('[data-r2-toast-close]').addEventListener('click', dismissToast);
    // Use Shopify's native checkout submission without intercepting or re-submitting it.
    toastEl.querySelector('form').addEventListener('submit', pauseToast);
  }
  const toast = (message, checkout = false) => {
    if (!toastEl) return;
    if (!toastEl.contains(document.activeElement)) toastTrigger = document.activeElement;
    pauseToast();
    toastEl.querySelector('[data-r2-toast-message]').textContent = message;
    toastEl.querySelector('form').hidden = !checkout;
    toastEl.classList.toggle('r2-toast-checkout', checkout);
    toastEl.hidden = false;
    positionToast();
    scheduleToast();
  };
  const cartDrawer = document.getElementById('r2-cart-drawer');
  let lastFocus;
  const openDialog = (id) => {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return;
    lastFocus = document.activeElement; dialog.showModal();
    document.body.classList.add('r2-modal-open');
    syncMobileControls();
    dialog.querySelector('input[type="search"]')?.focus();
  };
  const closeDialog = dialog => {
    if(!dialog || !dialog.open || dialog.classList.contains('is-closing'))return;
    if(!matchMedia('(prefers-reduced-motion: reduce)').matches){
      dialog.classList.add('is-closing');
      // Finish the actual exit animation before removing the native dialog/backdrop.
      const exits=dialog.getAnimations().filter(animation=>animation.effect?.target===dialog);
      Promise.race([Promise.allSettled(exits.map(animation=>animation.finished)),new Promise(resolve=>setTimeout(resolve,450))]).then(()=>{
        dialog.close();dialog.classList.remove('is-closing');
      });
    }else dialog.close();
  };
  if(cartDrawer){
    document.querySelectorAll('.r2-cart-link,[data-r2-mobile-nav] a[href]').forEach(link=>{
      if(new URL(link.href).pathname !== root+'cart')return;
      link.setAttribute('aria-haspopup','dialog');link.setAttribute('aria-controls','r2-cart-drawer');
    });
    cartDrawer.addEventListener('keydown',event=>{
      if(event.key!=='Tab')return;
      const controls=[...cartDrawer.querySelectorAll('a[href],button,input')].filter(el=>!el.disabled&&!el.closest('[inert]')&&el.getClientRects().length);
      const first=controls[0],last=controls.at(-1);
      if(event.shiftKey && document.activeElement===first){event.preventDefault();last?.focus();}
      else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first?.focus();}
    });
    document.addEventListener('click',event=>{
      const link=event.target.closest('a[href]');
      if(!link || event.defaultPrevented || event.button!==0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target==='_blank' || link.hasAttribute('data-r2-cart-full'))return;
      const url=new URL(link.href);
      if(url.origin!==location.origin || url.pathname!==root+'cart')return;
      event.preventDefault();openDialog('r2-cart-drawer');cartDrawer.querySelector('[data-r2-cart-page]').r2Cart.refresh();
    });
  }
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-r2-open]');
    if (opener) openDialog(opener.dataset.r2Open);
    const closer = event.target.closest('[data-r2-close]');
    if (closer) closeDialog(closer.closest('dialog'));
  });
  document.querySelectorAll('dialog.r2-dialog').forEach(dialog => {
    dialog.addEventListener('cancel',event=>{event.preventDefault();closeDialog(dialog);});
    dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(dialog); } });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('r2-modal-open');
      if (lastFocus?.closest('[data-r2-mobile-nav]')) scrollDirection = 'up';
      syncMobileControls();
      lastFocus?.focus({preventScroll:true});
      dialog.querySelectorAll('video').forEach(v => v.pause());
    });
  });
  document.querySelectorAll('[data-r2-autosubmit]').forEach(el => el.addEventListener('change', () => el.form.requestSubmit()));

  // Country changes use Shopify's native localization form, in an inline disclosure.
  const markets = [...document.querySelectorAll('[data-r2-market]')];
  markets.forEach(market => {
    const trigger = market.querySelector('summary');
    const search = market.querySelector('[data-r2-country-search]');
    const rows = [...market.querySelectorAll('[data-r2-country-row]')];
    const empty = market.querySelector('[data-r2-country-empty]');
    const status = market.querySelector('[data-r2-market-status]');
    const normalize = text => text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    const filter = () => {
      const query = normalize(search.value);
      rows.forEach(row => { row.hidden = !normalize(row.dataset.search).includes(query); });
      empty.hidden = rows.some(row => !row.hidden);
    };
    market.querySelector('[data-r2-country-search-wrap]').hidden = false;
    trigger.setAttribute('aria-expanded', 'false');
    market.addEventListener('toggle', () => {
      trigger.setAttribute('aria-expanded', String(market.open));
      if (market.open) {
        markets.forEach(other => { if (other !== market) other.open = false; });
        filter(); status.textContent = '';
        search.focus({preventScroll:true});
      } else {
        search.value = ''; filter();
      }
    });
    search.addEventListener('input', filter);
    search.addEventListener('keydown', event => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      const choices = rows.filter(row => !row.hidden).map(row => row.querySelector('button'));
      if (choices.length === 1) choices[0].form.requestSubmit(choices[0]);
      else choices[0]?.focus();
    });
    market.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        market.open = false; trigger.focus(); event.preventDefault();
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        const buttons = rows.filter(row => !row.hidden).map(row => row.querySelector('button'));
        if (!buttons.length) return;
        const current = buttons.indexOf(document.activeElement);
        const next = current < 0 ? (event.key === 'ArrowDown' ? 0 : buttons.length - 1) : (current + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[next].focus(); event.preventDefault();
      }
    });
    market.querySelectorAll('form').forEach(form => {
      form.addEventListener('submit', event => {
        if (form.classList.contains('r2-country-form') && !event.submitter?.matches('[data-r2-country]')) {
          event.preventDefault(); return;
        }
        if (form.getAttribute('aria-busy') === 'true') { event.preventDefault(); return; }
        const destination = new URL(location.href);
        destination.searchParams.delete('country'); destination.searchParams.delete('currency');
        const returnTo = form.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.value = destination.pathname + destination.search;
        form.setAttribute('aria-busy', 'true'); status.textContent = t("Updating your shopping region…");
      });
    });
    market.querySelector('[data-r2-language]')?.addEventListener('change', event => event.target.form.requestSubmit());
  });
  document.addEventListener('click', event => {
    markets.forEach(market => { if (!market.contains(event.target)) market.open = false; });
  });
  document.addEventListener('focusin', event => {
    markets.forEach(market => { if (!market.contains(event.target)) market.open = false; });
  });
  window.addEventListener('pageshow', () => {
    markets.forEach(market => market.querySelectorAll('form').forEach(form => form.removeAttribute('aria-busy')));
  });


  // Reserve independent space for consent, checkout shortcut and comparison.
  // Observe actual geometry, including late-loaded Shopify consent UI.
  const buyLayer = document.querySelector('[data-r2-sticky-buy]');
  const navLayer = document.querySelector('[data-r2-mobile-nav]');
  let cookieLayer;
  let layerFrame;
  const queueLayers = () => { if (!layerFrame) layerFrame = requestAnimationFrame(() => { layerFrame = null; syncBottomLayers(); }); };
  function syncBottomLayers() {
    const cookieHeight = cookieLayer && cookieLayer.getClientRects().length ? cookieLayer.getBoundingClientRect().height + 36 : 0;
    document.body.toggleAttribute('data-r2-consent-visible', cookieHeight > 0);
    const panelHeight = Math.max(buyLayer && !buyLayer.hidden ? buyLayer.getBoundingClientRect().height : 0, navLayer && !navLayer.hidden ? navLayer.getBoundingClientRect().height : 0);
    const style = document.documentElement.style;
    for (const [key, value] of [['--r2-cookie-offset', cookieHeight], ['--r2-buy-offset', panelHeight]]) {
      if (style.getPropertyValue(key) !== value + 'px') style.setProperty(key, value + 'px');
    }
  }
  const layerResize = new ResizeObserver(queueLayers);
  [buyLayer, navLayer].filter(Boolean).forEach(el => layerResize.observe(el));
  const watchCookie = () => {
    const next = document.querySelector('.shopify-pc__banner__dialog');
    if (next === cookieLayer) return;
    if (cookieLayer) layerResize.unobserve(cookieLayer);
    cookieLayer = next;
    if (cookieLayer) layerResize.observe(cookieLayer);
    queueLayers();
  };
  new MutationObserver(watchCookie).observe(document.body, {childList:true});
  watchCookie(); window.addEventListener('resize', queueLayers); syncBottomLayers();
  document.querySelectorAll('[data-r2-filters]').forEach(details => {
    const desktop = window.matchMedia('(min-width: 761px)');
    details.open = desktop.matches;
    desktop.addEventListener('change', event => { details.open = event.matches; });
  });
  const syncReviews = () => { document.querySelectorAll('[data-r2-reviews-link]').forEach(link => { link.hidden = !document.getElementById('judgeme_product_reviews'); }); };
  if (!document.getElementById('judgeme_product_reviews')) {
    const reviewObserver = new MutationObserver(() => {
      if (document.getElementById('judgeme_product_reviews')) { syncReviews(); reviewObserver.disconnect(); }
    });
    if (document.querySelector('[data-r2-reviews-link]')) reviewObserver.observe(document.body, {childList:true, subtree:true});
  }
  syncReviews();

  // Keep the selected price reachable while mobile shoppers choose options.
  // Desktop retains the purchase shortcut after the main form is passed.
  const mobileNavigation = document.querySelector('[data-r2-mobile-nav]');
  const mobileQuery = window.matchMedia('(max-width: 760px)');
  const primaryAdd = document.querySelector('[data-r2-add]');
  const primaryPrice = document.querySelector('[data-r2-product] [data-r2-price]');
  const pageFooter = document.querySelector('.r2-footer');
  let previousScroll = Math.max(0, window.scrollY), scrollDirection = 'up', scrollTravel = 0, bottomFrame;
  function syncMobileControls() {
    const sticky = buyLayer;
    const anchor = mobileQuery.matches ? (primaryPrice || primaryAdd) : primaryAdd;
    const footerRect = pageFooter?.getBoundingClientRect();
    const footerVisible = Boolean(footerRect && footerRect.top < innerHeight && footerRect.bottom > 0);
    const passed = Boolean(anchor && anchor.getBoundingClientRect().bottom <= 0);
    const modalOpen = Boolean(document.querySelector('dialog.r2-dialog[open]'));
    const showBuy = Boolean(sticky && passed && !footerVisible && !modalOpen);
    if (sticky && sticky.hidden === showBuy) sticky.hidden = !showBuy;
    const showNav = mobileQuery.matches && !showBuy && !modalOpen && (window.scrollY < 60 || scrollDirection === 'up');
    if (mobileNavigation && mobileNavigation.hidden === showNav) mobileNavigation.hidden = !showNav;
    queueLayers();
  }
  function queueMobileControls() {
    if (bottomFrame) return;
    bottomFrame = requestAnimationFrame(() => {
      bottomFrame = null;
      const y = Math.max(0, Math.min(window.scrollY, document.documentElement.scrollHeight - innerHeight));
      const delta = y - previousScroll;
      if (delta) {
        scrollTravel = Math.sign(delta) === Math.sign(scrollTravel) ? scrollTravel + delta : delta;
        if (Math.abs(scrollTravel) >= 12) scrollDirection = scrollTravel > 0 ? 'down' : 'up';
      }
      if (y < 16) scrollDirection = 'up';
      previousScroll = y;
      syncMobileControls();
    });
  }
  window.addEventListener('scroll', queueMobileControls, {passive:true});
  window.addEventListener('resize', queueMobileControls);
  window.addEventListener('hashchange', queueMobileControls);
  mobileQuery.addEventListener('change', queueMobileControls);
  // Catch price/layout changes and restored scroll positions without requiring a gesture.
  const purchaseVisibility = new IntersectionObserver(queueMobileControls);
  [primaryPrice, primaryAdd, pageFooter].filter(Boolean).forEach(el => purchaseVisibility.observe(el));
  window.addEventListener('pageshow', queueMobileControls);
  syncMobileControls();

  document.querySelectorAll('[data-r2-grade-image]').forEach(figure => {
    const image = figure.querySelector('img');
    const revealLens = () => figure.style.setProperty('--r2-grade-image', 'url("' + (image.currentSrc || figure.dataset.r2GradeImage) + '")');
    if (image.complete && image.naturalWidth) revealLens();
    else image.addEventListener('load', revealLens, {once:true});
  });

  // Model comparison is kept local to this browser and currency/market.
  const compareKey = 'reloopo.compare.v3.' + (window.Shopify?.country || '') + (window.Shopify?.currency?.active || '') + '.' + document.documentElement.lang;
  let selected = [];
  try { selected = JSON.parse(sessionStorage.getItem(compareKey) || '[]').filter(x => x && x.id && x.name && x.url).slice(0, 3); } catch (_) { selected = []; }
  const escape = (s) => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function renderComparison() {
    const tray = document.querySelector('[data-r2-compare-tray]');
    if (!tray) return;
    tray.hidden = selected.length === 0;
    tray.querySelector('[data-r2-compare-count]').textContent = t('compare_count', {count: selected.length});
    document.querySelectorAll('[data-r2-compare]').forEach(input => { input.checked = selected.some(p => p.id === input.value); });
    try { sessionStorage.setItem(compareKey, JSON.stringify(selected)); } catch (_) { /* Browsing remains functional without storage. */ }
  }
  document.addEventListener('change', e => {
    const input = e.target.closest('[data-r2-compare]'); if (!input) return;
    if (input.checked) {
      if (selected.length === 3) { input.checked = false; toast(t("Compare up to three devices. Clear one to choose another.")); return; }
      selected.push({id: input.value, name: input.dataset.name, price: input.dataset.price, url: input.dataset.url, image: input.dataset.image, options: input.dataset.options, specs: JSON.parse(input.dataset.specs || '[]')});
    } else selected = selected.filter(p => p.id !== input.value);
    renderComparison();
  });
  document.querySelector('[data-r2-compare-clear]')?.addEventListener('click', () => { selected = []; renderComparison(); });
  document.querySelector('[data-r2-compare-open]')?.addEventListener('click', () => {
    const content = document.querySelector('[data-r2-compare-content]');
    content.innerHTML = '<div class="r2-compare-grid">' + selected.map(p => '<article><img src="'+escape(p.image)+'" alt="'+escape(p.name)+'" width="300" height="300"><h3>'+escape(p.name)+'</h3><p><strong>'+escape(t("From"))+' '+escape(p.price)+'</strong></p><dl class="r2-compare-specs">'+(p.specs || []).map(([label, value]) => '<div><dt>'+escape(label)+'</dt><dd>'+escape(value)+'</dd></div>').join('')+'</dl><p class="r2-small">'+escape(p.options).replace(/; /g,'<br><br>')+'</p><p class="r2-small">'+escape(t("12-month warranty"))+'<br>'+escape(t("30-day free returns"))+'</p><a class="r2-button" href="'+escape(p.url)+'">'+escape(t("Choose yours"))+'</a></article>').join('') + '</div>';
    openDialog('r2-compare');
  });
  renderComparison();

  function initProduct(section) {
    if (section.dataset.r2Ready) return; section.dataset.r2Ready = 'true';
    const variants = JSON.parse(section.querySelector('[data-r2-variants]').textContent);
    const form = section.querySelector('.r2-product-form');
    const select = form.querySelector('[data-r2-variant-select]');
    const groups = [...form.querySelectorAll('[data-r2-option]')];
    const image = section.querySelector('#r2-main-product-image');
    const message = section.querySelector('[data-r2-form-message]');
    const add = form.querySelector('[data-r2-add]');
    const sticky = section.querySelector('[data-r2-sticky-buy]');
    const stickyAdd = section.querySelector('[data-r2-sticky-add]');
    let current = variants.find(v => String(v.id) === select.value);
    let adding = false;
    let lastOptionIndex = 0;
    const alternatives = form.querySelector('[data-r2-alternatives]');
    const alternativeList = form.querySelector('[data-r2-alternative-list]');
    const optionsHint = form.querySelector('[data-r2-options-hint]');
    const optionLabels = groups.map(group => new Map([...group.querySelectorAll('input')].map(input => [input.value, input.dataset.displayLabel || input.value])));
    const currency = section.dataset.currency;
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style: 'currency', currency}).format(cents / 100);
    const promotion = window.ReloopoPromotion?.init(section, {money, translate:t});
    const thumbnails = [...section.querySelectorAll('[data-r2-image]')];
    const thumbnailStrip = section.querySelector('.r2-thumbnails');
    const galleryButton = section.querySelector('[data-r2-zoom]');
    const imagePath = src => new URL(src, location.origin).pathname;
    let galleryIndex = Math.max(0, thumbnails.findIndex(b => b.getAttribute('aria-pressed') === 'true'));
    let displayedIndex = galleryIndex;
    let imageRequest = 0;
    let imageAnimation;
    const selectThumbnail = index => {
      thumbnails.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      const button = thumbnails[index];
      if (!button || !thumbnailStrip) return;
      const r = button.getBoundingClientRect(), strip = thumbnailStrip.getBoundingClientRect();
      if (r.left < strip.left + 2 || r.right > strip.right - 2) {
        // Scroll only the thumbnail strip; never move the page vertically.
        thumbnailStrip.scrollBy({left:(r.left+r.right-strip.left-strip.right)/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    };
    const setImage = (src, alt, direction = 0, targetIndex) => {
      if (!src || !image) return;
      const url = new URL(src, location.origin); url.searchParams.set('width', '1000');
      const index = targetIndex ?? thumbnails.findIndex(b => imagePath(b.dataset.r2Image) === url.pathname);
      galleryIndex = index;
      selectThumbnail(index);
      const request = ++imageRequest;
      const stage = image.closest('.r2-gallery-stage');
      stage?.removeAttribute('data-r2-image-loading');
      const commit = (next, srcset) => {
        if(request !== imageRequest)return;
        if(next){image.srcset=srcset;image.src=next.src;}
        image.alt=alt || image.alt;displayedIndex=index;
        const zoom=section.querySelector('[data-r2-zoom-image]');
        if(zoom){const enlarged=new URL(url);enlarged.searchParams.set('width','1400');zoom.dataset.src=enlarged.href;zoom.alt=image.alt;}
        if(next && !matchMedia('(prefers-reduced-motion: reduce)').matches && image.animate){
          imageAnimation?.cancel();
          imageAnimation=image.animate([{transform:'translateX('+direction*12+'px) scale(.98)'},{transform:'translateX(0) scale(1)'}],{duration:280,easing:'cubic-bezier(.22,1,.36,1)'});
        }
      };
      if(imagePath(image.currentSrc || image.src) === url.pathname){commit();return;}
      const next = new Image();
      const srcset = [240,480,720,960,1000].map(width=>{const responsive=new URL(url);responsive.searchParams.set('width',width);return responsive.href+' '+width+'w';}).join(', ');
      stage?.setAttribute('data-r2-image-loading','');
      next.sizes=image.sizes;next.srcset=srcset;next.src=url.href;
      next.decode().then(()=>commit(next,srcset)).catch(()=>{
        if(request!==imageRequest)return;
        // A failed image must not leave its thumbnail or zoom selected.
        galleryIndex=displayedIndex;selectThumbnail(displayedIndex);
      }).finally(()=>{if(request===imageRequest)stage?.removeAttribute('data-r2-image-loading');});
    };
    const stepImage = step => {
      const index=Math.max(0,Math.min(thumbnails.length-1,galleryIndex+step));
      if(index===galleryIndex || !thumbnails[index])return;
      const rtl=getComputedStyle(thumbnailStrip).direction==='rtl';
      setImage(thumbnails[index].dataset.r2Image,thumbnails[index].dataset.r2Alt,step*(rtl?-1:1),index);
    };
    if(galleryButton && thumbnails.length>1){
      let gesture=null,suppressClickUntil=0;
      const suppress=()=>{suppressClickUntil=performance.now()+400;};
      galleryButton.addEventListener('dragstart',event=>event.preventDefault());
      galleryButton.addEventListener('touchstart',event=>{if(event.touches.length>1){gesture=null;suppress();}},{passive:true});
      galleryButton.addEventListener('pointerdown',event=>{
        if(!event.isPrimary){gesture=null;suppress();return;}
        if(event.pointerType==='mouse' && event.button!==0)return;
        gesture={id:event.pointerId,x:event.clientX,y:event.clientY,dx:0,dy:0,axis:null};
        galleryButton.setPointerCapture(event.pointerId);
      });
      galleryButton.addEventListener('pointermove',event=>{
        if(!gesture || event.pointerId!==gesture.id)return;
        gesture.dx=event.clientX-gesture.x;gesture.dy=event.clientY-gesture.y;
        const x=Math.abs(gesture.dx),y=Math.abs(gesture.dy);
        if(!gesture.axis && Math.max(x,y)>12)gesture.axis=x>y*1.25?'x':'y';
        if(gesture.axis==='x' && event.cancelable)event.preventDefault();
      });
      galleryButton.addEventListener('pointerup',event=>{
        if(!gesture || event.pointerId!==gesture.id)return;
        const g=gesture;gesture=null;
        if(galleryButton.hasPointerCapture(event.pointerId))galleryButton.releasePointerCapture(event.pointerId);
        if(g.axis)suppress();
        const threshold=Math.min(60,Math.max(35,galleryButton.clientWidth*.12));
        if(g.axis==='x' && Math.abs(g.dx)>=threshold){const rtl=getComputedStyle(thumbnailStrip).direction==='rtl';stepImage((g.dx<0?1:-1)*(rtl?-1:1));}
      });
      galleryButton.addEventListener('pointercancel',()=>{gesture=null;suppress();});
      galleryButton.addEventListener('lostpointercapture',()=>{gesture=null;});
      galleryButton.addEventListener('click',event=>{if(event.detail>0 && performance.now()<suppressClickUntil){event.preventDefault();event.stopImmediatePropagation();}},true);
      galleryButton.addEventListener('keydown',event=>{
        if(event.key!=='ArrowLeft' && event.key!=='ArrowRight')return;
        event.preventDefault();const rtl=getComputedStyle(thumbnailStrip).direction==='rtl';stepImage((event.key==='ArrowRight'?1:-1)*(rtl?-1:1));
      });
    }
    function update(variant, changeURL = false) {
      current = variant;
      const options = groups.map(g => g.querySelector('input:checked')?.value);
      if (variant) {
        select.value = String(variant.id);
        section.querySelector('[data-r2-price]').textContent = money(variant.price) + ' ' + currency;
        section.querySelector('[data-r2-sticky-price]').textContent = money(variant.price) + ' ' + currency;
        const comparison = section.querySelector('[data-r2-compare-price]');
        const saving = section.querySelector('[data-r2-saving]');
        const hasSaving = variant.compare_at_price > variant.price;
        comparison.hidden = !hasSaving; saving.hidden = !hasSaving;
        comparison.textContent = hasSaving ? money(variant.compare_at_price) : '';
        saving.textContent = hasSaving ? t("Save") + ' ' + money(variant.compare_at_price - variant.price) : '';
        if (variant.featured_image) setImage(variant.featured_image.src, variant.featured_image.alt);
        if (changeURL) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
      } else {
        section.querySelector('[data-r2-price]').textContent = t("Unavailable combination");
        section.querySelector('[data-r2-sticky-price]').textContent = t("Choose another option");
        section.querySelector('[data-r2-compare-price]').hidden = true;
        section.querySelector('[data-r2-saving]').hidden = true;
        select.selectedIndex = -1;
      }
      promotion?.update(variant);
      const available = Boolean(variant?.available);
      add.disabled = !available || adding; stickyAdd.disabled = !available || adding;
      add.querySelector('span').textContent = adding ? t("Adding…") : available ? t("Add to cart") : variant ? t("Sold out") : t("Unavailable");
      stickyAdd.textContent = adding ? t("Adding…") : available ? t("Add to cart") : variant ? t("Sold out") : t("Unavailable");
      const stock = section.querySelector('[data-r2-stock]');
      stock.textContent = available ? t("Available to order") : variant ? t("This configuration is sold out. Try another colour, storage or condition.") : t("This combination is not offered. Please choose another option.");
      stock.classList.toggle('r2-stock-unavailable', !available);
      groups.forEach((group, index) => {
        group.querySelector('[data-r2-option-label]').textContent = group.querySelector('input:checked')?.dataset.displayLabel || options[index] || '';
        group.querySelectorAll('.r2-option').forEach(label => {
          const input = label.querySelector('input');
          const matches = variants.filter(v => v.options.every((o, i) => i === index ? o === input.value : o === options[i]));
          const unavailable = !matches.some(v => v.available);
          const offered = variants.some(v => v.options[index] === input.value);
          const availableElsewhere = variants.some(v => v.options[index] === input.value && v.available);
          // Absence from this market's variant data differs from temporarily sold out.
          label.hidden = !offered && !input.checked;
          label.classList.toggle('is-unavailable', unavailable);
          label.classList.toggle('has-alternatives', unavailable && availableElsewhere);
          label.querySelector('small').textContent = unavailable ? t(availableElsewhere ? 'Available in other configurations' : 'Unavailable') : '';
          // Preserve native radio interaction: never silently change another option.
        });
      });
      if (optionsHint) optionsHint.hidden = !form.querySelector('.r2-option.is-unavailable:not([hidden])');
      if (alternatives && alternativeList) {
        const candidates = available ? [] : variants.filter(v => v.available && v.options[lastOptionIndex] === options[lastOptionIndex]);
        alternatives.hidden = !candidates.length;
        if (!candidates.length) alternatives.open = false;
        alternativeList.replaceChildren(...candidates.map(candidate => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'r2-options__choice';
          button.dataset.variantId = String(candidate.id);
          button.textContent = candidate.options.map((value, index) => optionLabels[index].get(value) || value).join(' / ');
          return button;
        }));
      }
    }
    alternativeList?.addEventListener('click', event => {
      const button = event.target.closest('[data-variant-id]');
      if (!button) return;
      const variant = variants.find(v => String(v.id) === button.dataset.variantId && v.available);
      if (!variant) return;
      groups.forEach((group, index) => group.querySelectorAll('input').forEach(input => { input.checked = input.value === variant.options[index]; }));
      alternatives.open = false;
      message.textContent = '';
      update(variant, true);
      groups[lastOptionIndex].querySelector('input:checked')?.focus({preventScroll:true});
    });
    groups.forEach((group, index) => group.addEventListener('change', () => {
      lastOptionIndex = index;
      if (alternatives) alternatives.open = false;
      const values = groups.map(g => g.querySelector('input:checked')?.value);
      const match = variants.find(v => v.options.every((o, i) => o === values[i]));
      message.textContent = ''; update(match, true);
    }));
    window.addEventListener('popstate', () => {
      const id = new URL(location.href).searchParams.get('variant');
      const variant = variants.find(v => String(v.id) === id) || variants.find(v => v.available) || variants[0];
      groups.forEach((g, i) => { g.querySelectorAll('input').forEach(input => { input.checked = input.value === variant.options[i]; }); });
      update(variant);
    });
    thumbnails.forEach((button,index) => button.addEventListener('click', () => setImage(button.dataset.r2Image, button.dataset.r2Alt, 0, index)));
    section.querySelector('[data-r2-zoom]')?.addEventListener('click', () => { const zoom = section.querySelector('[data-r2-zoom-image]'); zoom.src = zoom.dataset.src; openDialog('r2-image-dialog'); });
    syncMobileControls();
    stickyAdd.addEventListener('click', () => form.requestSubmit(add));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!current?.available || adding) return;
      adding = true; update(current); message.textContent = '';
      try {
        const payload = {items:[{id: current.id, quantity: 1}]};
        if(cartDrawer){payload.sections=[cartDrawer.querySelector('[data-section-id]').dataset.sectionId];payload.sections_url=location.pathname+location.search;}
        const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(payload)});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || t("This device could not be added. Please try another option."));
        message.replaceChildren(document.createTextNode(t("Added to your cart.") + ' '));
        const link = document.createElement('a'); link.href = root + 'cart'; link.textContent = t("View cart & checkout"); message.appendChild(link);
        if (cartDrawer) { dismissToast(); openDialog('r2-cart-drawer'); await cartDrawer.querySelector('[data-r2-cart-page]').r2Cart.refresh(result.sections); }
        else toast(t("Added to your cart."), true);
        if (!cartDrawer) try { const cart = await (await fetch(root + 'cart.js')).json(); document.querySelectorAll('[data-r2-cart-count]').forEach(el => {el.textContent = cart.item_count; el.closest('a')?.setAttribute('aria-label', t('cart_count', {count: cart.item_count}));}); } catch (_) { /* Add succeeded; cart remains available. */ }
      } catch (error) { message.textContent = error.message || t("Could not add this device. Please try again."); }
      finally { adding = false; update(current); }
    });
    update(current);
  }
  document.querySelectorAll('[data-r2-product]').forEach(initProduct);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-r2-product]').forEach(initProduct));
})();
